const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

export function savePostLoginRedirect(path) {
  if (path && path.startsWith("/")) {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
  }
}

export function hasPostLoginRedirect() {
  return Boolean(sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY));
}

export function takePostLoginRedirect() {
  const path = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  if (path) {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  }
  return path;
}

export function redirectToLogin(returnPath) {
  savePostLoginRedirect(returnPath);
  window.location.href = "/?login=1";
}
